import { render, staticRenderFns } from "./aboutMe copy.vue?vue&type=template&id=9b56ae6a&scoped=true&"
import script from "./aboutMe copy.vue?vue&type=script&lang=js&"
export * from "./aboutMe copy.vue?vue&type=script&lang=js&"
import style0 from "./aboutMe copy.vue?vue&type=style&index=0&id=9b56ae6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56ae6a",
  null
  
)

export default component.exports